export async function lazyLoadRecorder() {
    try {
        const module = await import(/* webpackChunkName: "recorder" */ './startRecording');
        return module.startRecording;
    }
    catch (_a) {
        /* Prevent collecting the webpack ChunkLoadError as it is already collected as a RUM resource. */
    }
}
//# sourceMappingURL=lazyLoadRecorder.js.map